<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
    <path
      d="M721.408 645.192c51.077-67.062 81.777-150.436 81.777-241.039 0-220.027-178.995-399.032-399.032-399.032s-399.032 179.005-399.032 399.032 179.005 399.032 399.032 399.032c90.593 0 173.947-30.689 240.998-81.746l281.682 281.641c10.537 10.537 24.31 15.8 38.124 15.8s27.597-5.263 38.124-15.8c21.064-21.064 21.064-55.183 0-76.247l-281.672-281.641zM112.968 404.152c0-160.553 130.642-291.185 291.185-291.185s291.185 130.642 291.185 291.185-130.632 291.185-291.185 291.185-291.185-130.632-291.185-291.185z"
    ></path>
  </svg>
</template>
